import { utagLinkPDP } from 'features/tealium';

/*
  Create review widget is provided by TurnTo in their javascript,
  We need to wait for the widget to be added to the DOM,
  and using event delegation on known container node to track target elements
*/
function initProductReviewFormTracking () {

	const CONTAINER_SELECTOR = 'tt-o-modal__body';
	const SELECTORS = Object.freeze({
		addPhotoButton: 'tt-c-added-media__add-photo-btn',
		addVideoButton: 'tt-c-added-media__add-video',
		guidelinesLink: 'tt-c-review-form-header__guidelines-link',
		submitReviewButton: 'tt-c-review-form__submit',
		submitYoutubeVideoButton: 'tt-c-add-video__button-add',
		cancelYoutubeVideoButton: 'tt-c-add-video__button-back',
		removeMediaButton: 'tt-c-added-media__remove'
	});
	const reviewFormContainer = document.querySelector(`.${CONTAINER_SELECTOR}`);
	const trackAction = utagLinkPDP('TurnTo');

	function captureReviewFormClicks (e) {

		const { target } = e;

		// add photo
		if (target.classList.contains(SELECTORS.addPhotoButton) || target.closest(`.${SELECTORS.addPhotoButton}`)) {

			trackAction({
				eventAction: 'ReviewForm-Add-Photo-Review',
				eventLabel: window.shortSku
			});

		}

		// add video
		if (target.classList.contains(SELECTORS.addVideoButton) || target.closest(`.${SELECTORS.addVideoButton}`)) {

			trackAction({
				eventAction: 'ReviewForm-Add-Video-Review',
				eventLabel: window.shortSku
			});

		}

		// guidelines link
		if (target.classList.contains(SELECTORS.guidelinesLink)) {

			trackAction({
				eventAction:
					target.getAttribute('aria-expanded') === 'true'
						? 'ReviewForm-View-Guidelines'
						: 'ReviewForm-Hide-Guidelines',
				eventLabel: window.shortSku
			});

		}

		// submit review
		if (target.classList.contains(SELECTORS.submitReviewButton)) {

			trackAction({
				eventAction: 'ReviewForm-reviewSubmit',
				eventLabel: window.shortSku
			});

		}

		// submit youtube video
		if (target.classList.contains(SELECTORS.submitYoutubeVideoButton)) {

			trackAction({
				eventAction: 'ReviewForm-Add-YouTubeLink',
				eventLabel: window.shortSku
			});

		}

		// cancel youtube video (back button)
		if (target.classList.contains(SELECTORS.cancelYoutubeVideoButton)) {

			trackAction({
				eventAction: 'ReviewForm-Back-YouTube',
				eventLabel: window.shortSku
			});

		}

		// remove photo or video
		if (
			target.classList.contains(SELECTORS.removeMediaButton)
			|| target.closest(`.${SELECTORS.removeMediaButton}`)
		) {

			trackAction({
				eventAction: 'ReviewForm-Remove-Media',
				eventLabel: window.shortSku
			});

		}

	}

	function attachListener (element) {

		// remove existing listener to avoid duplicate events when form is closed and opened again
		element.removeEventListener('click', captureReviewFormClicks);
		element.addEventListener('click', captureReviewFormClicks);

	}

	if (!reviewFormContainer) {

		const reviewFormObserver = new MutationObserver((mutations, observer) => {

			const [ mutation ] = mutations;
			if (mutation.target.classList.contains(CONTAINER_SELECTOR)) {

				attachListener(mutation.target);
				observer.disconnect();

			}

		});
		// review form node is attached to document body
		reviewFormObserver.observe(document.body, { childList: true, subtree: true, attributes: false });

	} else {

		attachListener(reviewFormContainer);

	}

}

export default initProductReviewFormTracking;
